import { useTranslation } from 'react-i18next';
import { aiChatImage } from '@anytag/shared-assets';
import { cn } from '@anytag/shared-utils';
import { Button, ButtonProps } from '../../button-v2';
import { Icon } from '../../Icon';
import { useAiSidebar, useNavMenuSidebar } from './hooks';

type AiSidebarButtonProps = ButtonProps & {
  buttonText?: string;
  className?: string;
};

export const AiSidebarButton = ({ buttonText, className, ...props }: AiSidebarButtonProps) => {
  const { isAiSidebarOpen, isDisabledAiAssistant, setAiAssistantState } = useAiSidebar();
  const navMenuSidebar = useNavMenuSidebar(true);
  const { t } = useTranslation();

  if (isDisabledAiAssistant) {
    return null;
  }

  return (
    <Button
      variant="outline"
      size="lg"
      className={cn(
        'mr-px min-w-8 rounded-sm',
        { 'text-white! before:bg-black-60! after:bg-black-60!': isAiSidebarOpen },
        'gradient-border-button bg-white text-black-60',
        'hover:text-black-90',
        'disabled:pointer-events-auto disabled:opacity-60',
        className
      )}
      disabled={isAiSidebarOpen}
      onClick={() => {
        setAiAssistantState({ isAiSidebarOpen: true });
        navMenuSidebar.setSidebarState({ isOpen: false });
      }}
      {...props}
    >
      {isAiSidebarOpen ? (
        <Icon icon="ai-icon" size={16} variant="white" className="" />
      ) : (
        <img src={aiChatImage} alt="three stars" className="size-4.5" />
      )}
      {buttonText ? <span className="ml-1 text-base text-inherit">{t(buttonText)}</span> : null}
    </Button>
  );
};
